"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _core = require("@material-ui/core");

var css = _interopRequireWildcard(require("./ZipPayContract.styles"));

var Icons = _interopRequireWildcard(require("../../../components/icon/Icon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var defaultProps = {
  companyName: 'ZipMoney Payments Pty Ltd',
  businessNumber: 'ABN 58 164 440 993',
  companyWebsite: 'https://zip.co',
  companyPhone: '(02) 8294 2345',
  companyAddress: '14/10 Spring Street, Sydney, NSW, 2000, AU',
  companyEmail: 'hello@care.zip.co',
  disputeName: 'Australian Financial Complaints Authority (AFCA)',
  disputePhone: '1800 931 678',
  disputeMailbox: 'GPO Box 3, Melbourne, VIC, 3001',
  disputeWebsite: 'www.afca.org.au',
  disputeEmail: 'info@afca.org.au'
};

var ZipPayTermsAndConditions = function ZipPayTermsAndConditions(_ref) {
  var companyName = _ref.companyName,
      businessNumber = _ref.businessNumber,
      companyWebsite = _ref.companyWebsite,
      companyPhone = _ref.companyPhone,
      companyAddress = _ref.companyAddress,
      companyEmail = _ref.companyEmail,
      disputeName = _ref.disputeName,
      disputeMailbox = _ref.disputeMailbox,
      disputePhone = _ref.disputePhone,
      disputeWebsite = _ref.disputeWebsite,
      disputeEmail = _ref.disputeEmail;
  return (0, _jsxRuntime.jsx)(_core.Box, {
    css: css.body,
    children: (0, _jsxRuntime.jsxs)(_core.Box, {
      css: css.content,
      children: [(0, _jsxRuntime.jsx)(Icons.ZipPayLogo, {
        css: css.zipLogo,
        title: "zippay"
      }), (0, _jsxRuntime.jsx)("h2", {
        css: css.contractHeader,
        children: "Zip Pay - Terms and Conditions"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        mb: 1,
        children: [companyName, " ", businessNumber, " | W: ", companyWebsite, " | P:", ' ', companyPhone, " | A: ", companyAddress]
      }), (0, _jsxRuntime.jsx)("h3", {
        children: "Last update: 18 February 2021"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.textEmphasis,
        mt: 2,
        mb: 1,
        children: "About these Terms and Conditions"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "Your Contract comprises:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "1. The Zip Pay Schedule; and"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "2. These Terms and Conditions."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "Before you accept this offer and a Contract is formed you should read both documents carefully. Together they contain information we are required by law to give you and you should keep them for future reference."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.textEmphasis,
        mt: 2,
        mb: 1,
        children: "Privacy"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: ["We collect and use your personal information in accordance with our Privacy Policy (as amended from time to time) which you can view on the Zip Website", ' ', (0, _jsxRuntime.jsx)("a", {
          href: companyWebsite,
          target: "_blank",
          rel: "noreferrer",
          children: companyWebsite
        }), "."]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "1. Definitions"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "The following terms and expressions have the following meaning in the Terms and Conditions and Zip Pay Schedule:"
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Acceptance Date"
        }), " means the date the offer was accepted and the Contract formed"]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Access Method"
        }), " means: a) a method made available by us for you, and authorised and accepted by us, to act on an instruction or request to debit or credit an Account; and b) comprises the use of one or more components (including but not limited to) Password, PIN, e-signature, token, barcode or SMS Code."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Access Code"
        }), " means any one or more of your Password, PIN, Token, SMS Code, barcode and any other code we provide to you from time to time, that enables you to gain access to or use your Account and which you are required to keep secret."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Account"
        }), " means the Account we set up to record Transactions under this Contract."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Account Fee"
        }), " means the fee set out in the Zip Pay Schedule in respect of the services provided by Zip as set out in clause 3."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Account Limit"
        }), " means the amount specified as the Account Limit in the Zip Pay Schedule or, if varied by us, the Account Limit as varied and notified."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Account Number"
        }), " means the unique number that identifies your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Available Credit"
        }), " means the difference between the Account Limit and the sum of the Outstanding Balance and any Transactions authorised but not yet posted to your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "BPAY"
        }), " means the electronic payment scheme that is operated by BPay Pty Limited ABN 69 079 137 518."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "BPAY Facility"
        }), " means the BPAY Facility we allow you to use to make BPAY repayments to your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Business Day"
        }), " means a Day that is not a Saturday, Sunday or Public Holiday in New South Wales."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Buyer Protection"
        }), " means the service offered by Zip in respect of disputed Transactions with a Merchant as detailed on the Zip Website."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Closing Balance"
        }), " means the closing balance of your Account as described on a Statement."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Contract"
        }), " means the Contract between you and us comprising the Zip Pay Schedule and these Terms and Conditions."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Customer ID"
        }), " means a number we give you that identifies you as having an Account with us."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Direct Debit Request"
        }), " is an authority that allows us to debit your Nominated Account and to credit your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Direct Debit Request Service Agreement"
        }), ' ', "means your agreement with us in respect of your Direct Debit Request."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Disbursement Authority"
        }), " means your request for Zip to transfer funds from your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Drawdown"
        }), " means the borrowing of money under your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Due Date"
        }), " means the day by which you are required to make your repayments as set out in the Schedule."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Effective Date"
        }), " means the date that we assign to an amount that is debited, or where relevant, credited to your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Electronic Equipment"
        }), " means any electronic device which is capable of receiving emails including but not limited to a computer, telephone or mobile phone."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Invoice (Order or Receipt)"
        }), " means the document provided to you by the Merchant at the time of Purchase recording details of the Purchase."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Merchant"
        }), " means a retailer or supplier of goods or services who accepts Purchases."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Minimum Repayment Amount"
        }), " means the minimum amount you are required to pay us by the Due Date as notified on your Zip Pay Schedule or Statement."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Outstanding Balance"
        }), " means the difference between all amounts credited to and all amounts debited from your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Past Due Amount (Overdue)"
        }), " means the amount described as such on your Statement, which includes but not limited to repayments not made by the Due Date."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Password"
        }), " means the secret alphanumeric code used by you to access your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "PIN"
        }), " means the personal identification number used by you to access your account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Purchase"
        }), " means a Drawdown to pay a Merchant for the supply of goods and services."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "SMS"
        }), " means the telecommunications \u201Cshort message service\u201D technology which may allow text messages to be sent to your Mobile Phone."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "SMS Code"
        }), " means an authorisation code sent by SMS to your Mobile Phone to authorise a Transaction on your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Statement"
        }), " means a statement of account issued by us in respect of your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Terms and Conditions"
        }), " means this Zip Pay Terms and Conditions document which forms part of your Contract."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Transaction"
        }), " means a Purchase, or any other type of Drawdown, authorised by you and accepted and authorised by us under this Contract."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Transaction Amount"
        }), " means the dollar amount related to a Transaction posted to your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Transaction Date"
        }), " means the date that a Transaction is processed to your Account which is described as such in a Statement."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Unauthorised"
        }), " means without your knowledge or consent."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Unpaid Balance (Outstanding Balance)"
        }), ' ', "means the difference between all amounts credited to and all amounts debited from your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "we, us, our"
        }), " means Zip and includes its\u2019 successors and assigns and anyone acting on our behalf."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "you, your"
        }), " means the holder of the Account, and where more than one includes each of you individually and all of you collectively."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Zip"
        }), " means ", companyName, ' ', businessNumber, "."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Zip Customer Centre"
        }), " means a secure online service where Zip customers may log in to access their Account to obtain current or historical Account information, Transaction information, or provide Zip with new personal information, or change banking and repayment details."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Zip Pay Schedule"
        }), " means the Zip Pay Schedule which forms part of your Contract."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Zip App"
        }), " means the mobile application we make available to use your Account."]
      }), (0, _jsxRuntime.jsxs)("p", {
        css: css.lMarginBottomSmall,
        children: [(0, _jsxRuntime.jsx)("span", {
          css: css.importantTerm,
          children: "Zip Website"
        }), " means zip.co."]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "2. Contract"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "The Contract governs all Transactions made using the Account."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "3. Nature of the Account"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "The Account can be used by you for making Transactions in accordance with the Contract."
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          children: ["We incur costs in providing the services set out in the Contract, including but not limited to: Account set up and Account management; creating, monitoring and maintaining secure Access Methods and Access Codes; approving, authorising and verifying Transactions; providing Statements; managing and processing your Repayments through Direct Debit, Card or BPay; reviewing Unauthorised Transactions and providing Buyer Protection; managing and maintaining the Zip Website and Zip Customer Centre. We will charge an Account Fee each month for those costs incurred but will waive the Account Fee if you pay the Closing Balance in full by the Due Date.", ' ']
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "You are only permitted to have one active Zip Pay Account at any time."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "4. Electronic Acceptance"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: ["You:", (0, _jsxRuntime.jsx)(_core.Box, {
          children: "a) acknowledge and agree that both you and Zip have or will sign this Contract electronically; and"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "b) consent to providing your signature electronically for the purposes of this Contract, the Direct Debit Service Agreement, and the Privacy Act Authorisation and Disclosure."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "5. Account Activation"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "You cannot make a Transaction until your Account is activated. Your Account is activated by you accepting your Contract."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "6. Communications Between Us"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "a) By inserting your email address in the Zip Pay Schedule you authorise us to use email for communication purposes."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "b) By inserting your telephone number in the Zip Pay Schedule you authorise us to use this telephone number for communication purposes, which may include contacting you for the purposes of ensuring compliance with your obligations under this Contract."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "c) You must tell us if you change your name, your residential, postal or email address, your telephone or mobile number. If you update your email address or mobile number via the Zip Customer Centre, Zip Website or Zip App you authorise us to communicate with you as per both 6a) and 6b) using the updated information."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "d) If you have to give us a document or notice then you can:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "(i) leave it at our office address as shown on the Zip Pay Schedule, or any other address we tell you; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(ii) email it to an email address we tell you."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "e) Unless stated otherwise, if we need to give you a document or notice we can do so by:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "(i) delivering it to you personally; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(ii) leaving it at, or sending it by post to your residential or postal address last known to us; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(iii) emailing it to the email address you have provided to us."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "f) If you have provided us with your email address you must:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "(i) regularly check your email address to see if you have received any emails from us;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(ii) maintain and check your Electronic Equipment and your email address regularly to ensure it is always capable of receiving emails from us; and"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(iii) you are responsible for printing or saving important documents, and we strongly recommend that you do so."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "7. Making Transactions on your Account"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "We allow you to make a Transaction on your Account through any Access Method we determine which may include:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "a) making a Purchase with any Merchant authorised by us; or"
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          children: ["b) at the Zip Website (", companyWebsite, ");"]
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "c) via the Zip App; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "d) any other Access Method we authorise from time to time."
        })]
      }), (0, _jsxRuntime.jsx)("p", {
        children: "Transactions on your Account are initiated and authorised using a combination of Password, PIN, barcode and SMS Code."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "Note that not all Access Methods may be available for your Account."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "We are not liable for any refusal or failure of a Merchant to accept your instructions at any time or for the quality, performance or other matters in relation to goods and services bought with Transactions on your Account unless this is required by law or a code or is covered by the Terms and Conditions."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "All Transactions made from your Account will be debited to your Account and you agree to repay them to us in accordance with the Contract. Daily or periodical transaction limits may apply on the number or value of Transactions on your Account. If we apply or vary any daily or periodic transaction limit we will advise you."
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "e) All Transactions made on your Account must be authorised by us. Circumstances where Transactions may not be authorised under clause 7e) are where:"
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          pl: 2,
          children: [(0, _jsxRuntime.jsx)(_core.Box, {
            children: "(i) the Transaction would mean you are in excess of your Account Limit"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "(ii) your Account has a Past Due Amount or is in default; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "(iii) there has been unsatisfactory Account performance or conduct; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "(iv) there is suspicious or fraudulent conduct; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "(v) we become aware of a change in your financial circumstances that may affect your ability to make repayments under the Contract; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "(vi) there is no active direct debit set up for Account repayments; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "(vii) you have breached or we become aware that you are likely to breach any Terms or Conditions of this Contract; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "(viii) we become aware you have made multiple attempts to apply for additional Zip Pay Accounts; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "(ix) we become aware you have multiple Zip Pay accounts; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "(x) there is, has been, or we become aware of a potential business disruption or technology issue which affects a Transaction, your Account or the services we provide under the Contract."
          })]
        })]
      }), (0, _jsxRuntime.jsx)("p", {
        children: "If you have an issue with the Merchant in respect of the Transaction you may wish to contact us and ask whether Buyer Protection applies."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "8. Repayments "
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "a) You must pay us the Minimum Repayment Amount shown on your Statement by the Due Date shown on your Statement. You may choose to pay more if you wish but you must not put the balance in your Account in to credit."
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: ["b) An explanation of the Minimum Repayment Amount is set out in the Zip Pay Schedule.", ' ']
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "c) You are responsible for ensuring that payment is received by us on time on or before the Due Date."
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: ["d) If the Due Date is not a Business Day, or on the 29th, 30th or 31st of a month that does not include such a day, you must ensure it is received by us by the next Business Day.", (0, _jsxRuntime.jsxs)("p", {
          children: ["If your Statement shows a Past Due Amount (Overdue) or refers to an amount \u201CDue Immediately\u201D you must also pay us that amount immediately on receipt of your Statement.", ' ']
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "9. Application of Repayments"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "A repayment will be treated as being made on the Effective Date. The Effective Date for each repayment will be set out in your Statement."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "You must allow sufficient time for us to receive your repayment by the due date. Third parties who send us or process your repayment on your behalf are not our agents and receipt of a repayment, and the Effective Date will be the date and time we receive your repayment. We will apply your repayments to your Unpaid Balance."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "10. How to make Repayments"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "Repayments must be made in a manner shown on your Statement, as amended from time to time, which may include the following:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "a) direct debit from your Nominated Account (by completing a Direct Debit Request); or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "b) BPAY from any participating financial institution (please refer to your Statement or the Zip Customer Centre for further information on how to make a repayment to us Using BPAY); or"
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          children: ["c) by signing in to your account at ", companyWebsite, " and using one of the payment methods identified; or"]
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "d) By any other method we advise you of."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mt: 1,
        children: "A direct debit must be active as a repayment method for your Account at all times unless agreed by us."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "11. Account Limit"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "Your Account Limit is the amount specified in the Zip Pay Schedule or such other amount as we may authorise. Subject to any Transaction limits you may Drawdown up to your Account Limit. You must ensure that you do not exceed your Account Limit. If your Account Limit is reached or exceeded fees and Government charges will continue to be charged to your Account even if debiting these items results in you exceeding your Account Limit. Your Account Limit does not change because your Account balance exceeds your Account Limit. Any excess above your Account Limit shall be immediately repayable by you without the necessity for Zip to demand repayment. Should your Account reach the Account Limit, you should not initiate and we may not authorise further Transactions on your Account."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "We may increase your Account Limit at your request or with your written consent, subject to our approval. You may request us to reduce your Account Limit at any time."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "Your initial Account Limit is the amount set out in the Zip Pay Schedule. Your Account Limit is set based on our assessment of your circumstances. We may reduce your Account Limit at any time per Clause 20. If you are unhappy with the decreased limit you can terminate your Account by paying the Outstanding Balance, plus any accrued fees and charges. There is no additional cost to do so."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "12. Credit Balances"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "The Account must not have a credit balance. However, if your Account has a credit balance, Transactions on your Account will firstly be applied to reduce your credit balance."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "We will not pay interest on the credit balance of your Account."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "13. Fees Payable"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "You must pay us the fees and charges in the amounts and the circumstances set out in the Zip Pay Schedule, as varied or updated from time to time. We will debit the fees and charges to your Account when they are payable and they will appear on your Statement."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "14. Government Fees and Charges"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "You must pay all Government duties, rates, taxes and charges now, or in the future, charged on or otherwise payable in relation to your Contract or your Transactions. You must pay us the amounts in accordance with the relevant legislation, whether or not you are liable for them under that legislation. We may debit these to your Account and they will appear on your Statement."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "15. Accessing your Account"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "We may provide you with access to your Account, at our absolute discretion, to obtain information or give us instructions using any one or more of the following Access Methods:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "a) Zip Website;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "b) our Zip Customer Centre;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "c) our customer service team;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "d) our Zip App;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "e) A Merchant recognised by us; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "f) Any other method that we determine from time to time"
        })]
      }), (0, _jsxRuntime.jsx)("p", {
        children: "Access to your Account may require a one of, or a combination of, a Password, PIN or SMS Code. We will try (without any legal obligation) to provide access on a 24-hour continuous basis. However, circumstances may not always make this possible."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "16. Password Access to your Account"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "You must keep your Password and PIN secret and secure. This is because your Password or PIN permits the holder of the Password or PIN to access the Zip Website or the Zip App, and therefore, information about your Account and to give instructions in respect of your Account. Please ensure you do not record or save your Password on your computer or on any emails. If you have lost, forgotten, or misplaced your Password, or believe someone knows it, or believe there has been unauthorised access to your Account, please contact us to cancel your Password and to re-set your Password."
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          mb: 1,
          children: "Your Password should also:"
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          pl: 2,
          children: [(0, _jsxRuntime.jsx)(_core.Box, {
            children: "a) Be changed regularly via the Zip Website or our customer service team, be easy to memorise but difficult to guess and not have any connection with you (such as birthday, telephone number, car registration etc);"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "b) Not be disclosed to anyone else, not even family members or friends; and"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "c) Not be stored in your computer programmable function keys."
          })]
        })]
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          mb: 1,
          children: "You should also ensure that:"
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          pl: 2,
          children: [(0, _jsxRuntime.jsx)(_core.Box, {
            children: "a) your computer is free from viruses and any form of password recording program or mechanism;"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "b) your computer is not left unattended while logged onto the Zip Website; and"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "c) you shut down all browser windows used to gain access to the Zip Website and that the \"back\" function or similar cannot be used to trace your activities."
          })]
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "17. Your email address and mobile phone number"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "We may use your email address as part of our secure log in and/or Transaction authorisation process, or to advise you of any enhancement or changes to your Account which may alter our delivery of, or your ability to use your Account. You need to keep your email address current. You may update your email address by contacting us or Using the Zip Customer Centre, Zip App or any other method we make available. If you do not provide us with a correct email address, you may not receive important information and Statements regarding your Account."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "We may use your Mobile Phone number as part of our secure log in process, or to send you SMS Codes as part of the Transaction authorisation process and other information relevant to this service. You need to keep your Mobile Phone number current. You may update your Mobile Phone number by contacting us or using the Zip Customer Centre or Zip App. If you do not provide us with your correct Mobile Phone number you may not be able to transact on your Account, and you may not be notified of important information relevant to the use of your Account."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "18. Liability for Unauthorised Transactions on your Account"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "You are liable to us in respect of an Unauthorised Transaction when:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "a) you have failed to advise us of any suspected or unauthorised use of your Account; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "b) you have provided information regarding your Password or PIN to someone whether knowingly or not; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "c) you have committed fraud."
        })]
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          mb: 1,
          children: "You are not liable to us in respect of an Unauthorised Transaction when:"
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          pl: 2,
          children: [(0, _jsxRuntime.jsx)(_core.Box, {
            children: "d) the Unauthorised transaction occurred after you had advised us of suspected unauthorised use of your Account; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "e) A Transaction is incorrectly credited or debited to your Account by us; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "f) It is clear that you have not contributed to the loss; or"
          }), (0, _jsxRuntime.jsx)(_core.Box, {
            children: "g) It is determined by us, acting reasonably, that you were not directly or indirectly responsible for the relevant Unauthorised Transaction"
          }), (0, _jsxRuntime.jsxs)(_core.Box, {
            children: ["h) It was caused by the fraudulent or negligent conduct of employees or agents of:", (0, _jsxRuntime.jsxs)(_core.Box, {
              pl: 2,
              mb: 1,
              children: [(0, _jsxRuntime.jsx)(_core.Box, {
                children: "(i) us;"
              }), (0, _jsxRuntime.jsx)(_core.Box, {
                children: "(ii) any Merchant; relating to a forged, faulty, expired, fraudulent or a cancelled Transaction"
              })]
            })]
          })]
        })]
      }), (0, _jsxRuntime.jsx)("p", {
        children: "If you are concerned about any suspect activity on your Account, please contact our customer service team immediately."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "19. Statements"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "You will receive a Statement each month where there has been a Transaction made on your Account or where there is an Outstanding Balance in the period. You are also entitled to ask for a Statement at any time. We may charge you a fee to provide Statements on request. All our Statements are provided electronically unless specifically requested otherwise. It is your responsibility to check your Statement carefully as soon as you receive it and immediately notify us of any errors or unauthorised Transactions. So that you can check your Statement you may wish to keep all your records of all your Invoices."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "20. Changes to your Contract"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "Subject to the law we may vary the following terms of your Contract at any time without your consent, by providing at least 30 days notice when:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "a) Changing the amount, frequency, time for repayment, or method of calculating any repayments;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "b) Changing the amount, frequency or time for payment of any fee or charge;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "c) Imposing a new fee or charge;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "d) Making any material change to the Contract:"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "e) We impose, remove or adjust daily or periodic transaction limits."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "Subject to the law we may vary the following term of your Contract at any time without your consent and without prior notice if we have reason to believe your financial circumstances have changed or where we believe, acting reasonably, the Credit Limit is not suitable when:"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        pl: 2,
        children: (0, _jsxRuntime.jsx)(_core.Box, {
          children: "f) Reducing (but not increasing) the Credit Limit"
        })
      }), (0, _jsxRuntime.jsx)("p", {
        children: "We will advise you of any change should we reduce the Credit Limit under clause 20f). For the avoidance of doubt, this Clause 20 does not permit the introduction of a new fee charged to close your Account. There is no term on your Contract, and there is no fee to payout the balance or close the Account. If you are unhappy with the any of the changes to the Contract you can terminate your Account by paying the Outstanding Balance, plus any accrued fees and charges."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "We are not obliged to give you any advance notice if an immediate change to the Terms and Conditions is deemed necessary for the security of individual accounts."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "21. Changes in your circumstances"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "You must contact us immediately to inform us of a change in your particulars, including when:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "a) your contact details change (including phone numbers, residential, delivery and email address);"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "b) you have changed your name, either first or last name;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "c) you have been declared bankrupt or commit an act of bankruptcy;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "d) you would like to appoint a person to act on your behalf under a power of attorney; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "e) your payment instructions change (for example you may wish to change your current Nominated Account details)."
        })]
      }), (0, _jsxRuntime.jsx)("p", {
        children: "You must also tell us if you think there is any information that we should be aware of about your ability to comply with this Contract."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "We may require written proof for changes in personal details."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "22. Service of Notices"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "To the extent permitted by law, any notice or document given by us under this Contract or required by law or industry code or guideline may be given in writing, can be signed by any of our officers, and can be delivered personally, by pre-paid mail to the address you have nominated for delivery of notices and documents, or by email to your nominated email address, or if no such address has been nominated by you, your address as last known to us. Any such notice or document shall be deemed to have been received by you when it would have been delivered in the ordinary course of post or, if delivered by email, at the time it becomes capable of being retrieved by you at your email address."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "23. Applicable Law"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "Your Contract is subject to the laws of the State or Territory in which you are ordinarily a resident when you accept our offer."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "24. Evidence"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "You agree that any record of a Transaction provided to us by a Merchant is admissible evidence of the Transaction and of the amount shown and that, unless the contrary is established, it is conclusive evidence."
      }), (0, _jsxRuntime.jsxs)("p", {
        children: ["Further, you also agree that any statement (including, but not limited to, a statement of account or a default notice) that has been given to you by us or a person acting on our behalf, is admissible evidence of that fact or matter in the statement and that, unless contrary evidence is established, it is conclusive evidence.", ' ']
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "25. Assignments of rights and disclosures"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "This Contract cannot be assigned by you without our prior written consent."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "You authorise us to assign, transfer or otherwise deal with our rights under this Contract without the need to obtain further consent from you. This will not affect your rights or obligations under the Contract."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "You consent to us disclosing on a continuous basis any information or documents relating to you we consider necessary to assign such rights, manage the assigned Contract and assess your total liabilities to us and any related entity."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "26. Exercise of our rights"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "If we decide not to exercise a right, remedy or power, this does not mean we cannot exercise it later and you agree we are not stopped from doing so. In addition we are not liable for any loss caused by exercising or attempting to exercise a right remedy or power or not exercising it, whether or not it is caused by our negligence."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "27. Closure of, or denial of, access to your Account"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "a) You may request that your Account be closed by:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "(i) Giving us notice in writing or contacting us; and"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(ii) Paying any Outstanding Balance in full, including Transactions, and fees and charges not yet shown on your Account."
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "If you request that we close your Account:"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(i) No further Transactions will be permitted; and"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(ii) your obligations under this Contract will continue until you pay us the total amount you owe us (including fees and charges and other amounts you become liable to pay under the Contract and which are not yet debited to the Account)."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mt: 1,
        mb: 1,
        children: "b) We may decide at any time, subject to 27c), without prior notice and whether or not you are in default to:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "(i) Suspend your Account; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(ii) Close your Account."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "We will advise you if we do so."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "Any actions taken by us under Clause 27b) do not effect the amounts you owe us under this Contract."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mt: 1,
        mb: 1,
        children: "c) Circumstances where your Account may be suspended or closed as per 27b) (i) or (ii) are where:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "(i) your Account has a Past Due Amount or is in default; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(ii) there is suspicious or fraudulent conduct; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(iii) we become aware of a change in your financial circumstances that may affect your ability to make repayments under the Contract; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(iv) there is no active direct debit set up for Account repayments; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(v) You have breached or we become aware that you are likely to breach any Terms or Conditions of this Contract; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(vi) You have made multiple attempts to apply for additional Zip Pay Accounts."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "Notice will be provided when you access or transact on your Account"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mt: 1,
        mb: 1,
        children: "d) In the event of either27b)(i) or 27b)(ii):"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "(i) you will not be allowed to make any further Transactions; and"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(ii) you must continue to pay the Minimum Repayment Amount each month and, if relevant any Past Due Amount."
        }), (0, _jsxRuntime.jsx)("p", {
          children: "Subject to 27c), if we suspend your Account, you may continue to access information about your Account through the Zip Website or Zip App."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mt: 1,
        children: "e) We may, at any time, deny access to your Account for any reason including suspected fraudulent use, non-compliance with the Terms and Conditions, where such non-compliance is likely to effect Zip\"s likelihood of being repaid under the Contract or affect the ability of Zip to provide the services under the Contract, or if we consider a security issue has arisen which requires further investigation."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "28. Default"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "You are in default if:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "a) The payment of a Minimum Repayment Amount is not made by the relevant Due Date; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "b) The Outstanding Balance of your Account exceeds the Account Limit; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "c) You do not comply with any other terms or conditions of this Contract, and where such non compliance is likely to effect Zip\"s likelihood of being repaid under the Contract; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "d) We believe, on reasonable grounds, that we were induced by fraud on your part to enter into this Contract; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "e) You make any materially false or misleading representation to us; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "f) You use your Account for any unlawful, fraudulent or improper activity; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "g) You have more than one Zip Pay Account."
        })]
      }), (0, _jsxRuntime.jsx)("p", {
        children: "If you are in default we may send you a default notice specifying the details of the default, how it may be corrected, and how long you have to correct it."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "If you do not remedy the default within the time allowed then all amounts you owe us (including amounts which have been accrued but not yet debited to your Account) will be immediately due and payable. We may exercise our rights under this Contract at law."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "Enforcement expenses may be payable if you default. You must pay to us all reasonable enforcement expenses incurred by us or our agents in exercising our rights because you default. Enforcement expenses when charged are debited to your Account, and when we do they will be added to and form part of the Unpaid Balance."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "Enforcement expenses may include reasonable solicitors\u2019 legal costs and the reasonable expenses of our staff and our facilities reasonably incurred in relation to any enforcement."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "29. Exclusions of Warranties and Representations"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "a) We do not warrant that recognised Merchants will accept Purchases. You should always enquire beforehand before selecting goods or services."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "b) We do not accept any responsibility should a Merchant refuse to accept or honour the Transaction."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "c) Unless the law requires, we are not responsible for any defects in the goods and services acquired by you through the use of the Account. You acknowledge and accept that all complaints about these goods and services must be addressed to the Merchant who provided or sold those goods and services. Even if you make a complaint or dispute regarding a Transaction you must still pay us all amounts and charges charged to your Account. However, if you dispute a Transaction made using your Account within 30 days of that Transaction, in certain circumstances, and after due process and investigation, we may seek a reversal of the Transaction on your behalf (for example, where you did not receive the goods or services paid for). This involves the \u201Ccharge back\u201D or debiting of the Transaction from the Merchant\u2019s account with its financial institution, and a crediting of that amount to your Account."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "30. Warranties"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        children: ["You agree that all statements made, information and documents provided in connection with the application to us for the Account and all representations which you have made or may make to us whilst the Account is open are true and correct. You acknowledge that we have relied upon the correctness of those statements, documents or representations in entering into the Contract and will continue to do so in our dealings with you.", ' ']
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "31. Legal rights"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "You have certain rights at law which cannot be limited or excluded. Applicable law includes but is not limited to Australian Consumer Law and the Privacy Act 1988.Nothing in the Terms and Conditions limits or excludes those rights, however our liability is limited to the maximum extent permitted by law."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "If any provision of the Contract is or becomes invalid, unenforceable or breaches any mandatory law or applicable code then it is deleted and will not affect the remaining parts of the Contract."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "32. Loss or damage if you breach your Contract"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "Subject to the Terms and Conditions and in addition to any rights we have to recover the Outstanding Balance of your Account, you agree to pay us for any loss, damage or costs we might have if:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "a) you breach any law or regulation that applies to your Account or Transactions;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "b) you do not use your Account correctly;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "c) you breach your Contract; or"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "d) we are not responsible for any loss is if a Password is stolen or misused except where we agree in the Terms and Conditions or where by law or applicable code you are not responsible for any loss."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "33. Appointment of signatories and attorneys"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "You can appoint a signatory or another person (attorney) under power of attorney to act on your behalf and access your Account. We may require the signatory or attorney to sign our prescribed forms before they can access your Account. We will require satisfactory documentary evidence of the attorney\u2019s appointment before we can allow the attorney to access your Account. We can refuse to accept any instructions from any signatory or attorney."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "34. Interception and recording of communications"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "You agree and acknowledge that we can intercept, record, read or view by any means any communication you may have with or make to us by any means. Communications include telephone calls, emails and any other form of electronic or wireless communication."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "35. Anti-Money Laundering and Counter-Terrorism Financing"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "a) You acknowledge that:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "(i) we are subject to various Anti- Money Laundering and Counter-Terrorism Financing laws (AML/CTF) which include prohibitions against any person dealing with the proceeds or, or assets used in, criminal activity (wherever committed) and from dealing with any funds or assets of, or the provision of finance to, any person or entity involved (or suspected of involvement) in terrorism or any terrorist act; and"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(ii) the AML/CTF laws may prohibit us from offering services to, or entering into, or conduction Transactions with you."
        })]
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mt: 1,
        mb: 1,
        children: "b) You agree:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          children: "(i) That we are not required to accept or execute any instruction, or take any other action under, or in connection with, the Contract if we are not satisfied as to your identity, or where we suspect on reasonable grounds that by doing so we may breach the AML/CTF laws;"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(ii) That we may delay, block or refuse to release any monies on your instructions, if we believe on reasonable grounds that to do so may breach any law in Australia or of any other country, including the AML/CTF Laws; and"
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "(iii) That we will incur no liability to you for any loss you suffer (including consequential loss) however caused by reason of any action taken or not taken by us contemplated in paragraph 35b) (i) and (ii)."
        })]
      }), (0, _jsxRuntime.jsx)("p", {
        children: "You agree to provide all information and documents to us which we reasonably require to comply with any law in Australia or any other country, including the AML/CTF Laws and agree that we may disclose information which you provide to us, or about Transactions you conduct, or seek to conduct, with us where we required to do so by any such laws. You undertake that the payment of monies in accordance with this Contract or any instructions given by you will not breach the AML/CTF laws and you agree to indemnify us against any loss arising where you breach this undertaking."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "36. No set off of counterclaim"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: "You agree to make all payments you owe us under the Contract in full, without any set-off or counterclaim. This means that you cannot deduct anything that you claim we owe you, or could in the future owe you."
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        css: css.contractTermsKey,
        children: "37. Feedback and complaint management"
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        mb: 1,
        children: "You may contact us with your feedback including any complaints by:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        pl: 2,
        children: [(0, _jsxRuntime.jsxs)(_core.Box, {
          children: ["a) Emailing us at ", companyEmail]
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          children: ["b) Calling our customer service team on ", companyPhone]
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          children: "c) Clicking on the contact us button in the Customer Centre"
        })]
      }), (0, _jsxRuntime.jsx)("p", {
        children: "We will process your complaint as per our complaints policies and procedures."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "If your complaint cannot be resolved promptly, our Complaints Officer will take responsibility and work with you to resolve the matter. A final written response will be provided within 45 days."
      }), (0, _jsxRuntime.jsx)("p", {
        children: "If you remain dissatisfied with the outcome and would like an independent review of the complaint and the result you can refer your complaint to:"
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        mt: 2,
        children: [(0, _jsxRuntime.jsx)("strong", {
          children: disputeName
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          children: ["Phone: ", disputePhone]
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          children: ["Internet:", ' ', (0, _jsxRuntime.jsx)("a", {
            href: "{dispute-website}",
            target: "_blank",
            children: disputeWebsite
          })]
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          children: ["Email: ", disputeEmail]
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          children: ["Mail: ", disputeMailbox]
        })]
      }), (0, _jsxRuntime.jsxs)(_core.Box, {
        mt: 2,
        children: [(0, _jsxRuntime.jsx)(_core.Box, {
          css: css.contractTermsKey,
          children: "Buy Now Pay Later Code of Practice and the Code Compliance Committee"
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          mb: 1,
          children: ["Zip is a code compliant member of the AFIA Buy Now Pay Later Providers Group and a signatory of the AFIA Buy Now Pay Later Code of Practice (Code). The Code applies to Buy Now Pay Later products or services provided by code compliant members. Zip is committed to ensuring that it\u2019s Buy Now Pay Later product, Zip Pay, is compliant with standards of the Code. You can access further information about the Code here;", (0, _jsxRuntime.jsxs)(_core.Box, {
            children: [(0, _jsxRuntime.jsx)("a", {
              href: "https://afia.asn.au/AFIA-Buy-Now-Pay-Later-Code-of-Practice",
              target: "_blank",
              rel: "noreferrer",
              children: "https://afia.asn.au/AFIA-Buy-Now-Pay-Later-Code-of-Practice"
            }), "."]
          })]
        }), (0, _jsxRuntime.jsx)(_core.Box, {
          mb: 1,
          children: "If you have a dispute about your Zip Pay Account, which you have not been able to resolve either by directly contacting us or subsequently referring the matter to AFCA, you can then report an alleged breach of the Code to the AFIA Code Compliance Committee (\u2018CCC\u2019). The CCC is an independent committee that has been established to monitor our compliance with this Code (as outlined in the Terms of Reference for the CCC). The CCC can investigate any \u201CAlleged Breaches\u201D of this Code (as defined in the Terms of Reference for the CCC), at its discretion. Where it is appropriate for it to do so, the CCC can make a range of recommendations to resolve a Complaint. Zip will co-operate and comply with all reasonable requests of the CCC in the performance of its monitoring and investigative functions."
        }), (0, _jsxRuntime.jsxs)(_core.Box, {
          mb: 1,
          children: ["You can access further information about the CCC here;", (0, _jsxRuntime.jsxs)(_core.Box, {
            children: [(0, _jsxRuntime.jsx)("a", {
              href: "https://afia.asn.au/post/Media-Release-AFIA-Appoints-BNPL-Code-Compliance-Committee-Chair-and-Confirms-New-Publication-exist",
              target: "_blank",
              rel: "noreferrer",
              children: "https://afia.asn.au/post/Media-Release-AFIA-Appoints-BNPL-Code-Compliance-Committee-Chair-and-Confirms-New-Publication-exist"
            }), "."]
          }), "To lodge a Complaint with the CCC, contact them at", (0, _jsxRuntime.jsxs)(_core.Box, {
            children: [(0, _jsxRuntime.jsx)("a", {
              href: "CCC-BNPL@afia.asn.au",
              target: "_blank",
              rel: "noreferrer",
              children: "CCC-BNPL@afia.asn.au"
            }), "."]
          })]
        })]
      })]
    })
  });
};

ZipPayTermsAndConditions.propTypes = {
  companyName: _propTypes.string,
  businessNumber: _propTypes.string,
  companyWebsite: _propTypes.string,
  companyPhone: _propTypes.string,
  companyAddress: _propTypes.string,
  companyEmail: _propTypes.string,
  disputeName: _propTypes.string,
  disputeMailbox: _propTypes.string,
  disputePhone: _propTypes.string,
  disputeWebsite: _propTypes.string,
  disputeEmail: _propTypes.string
};
ZipPayTermsAndConditions.defaultProps = defaultProps;
var _default = ZipPayTermsAndConditions;
exports["default"] = _default;